import { Injectable } from "@angular/core";
import { ApiService } from "@uranda/commons";
import { Wallet } from "../app/models/wallet.model";

export interface PaymentIntentResponse {
  clientSecret: string;
  amount: number;
  currency: string;
  invoiceId: number;
  /** STRIPE: Payment Element con clientSecret; POK: redirect alla pagina di pagamento ospitata. */
  provider?: 'STRIPE' | 'POK';
  redirectUrl?: string;
}

@Injectable({
    providedIn: 'root'
})
export class WalletService extends ApiService {

    wallet?: Wallet;

    async getWallet() {
        const response = await this.get('/v1/wallet/debt');
        this.wallet = response.data;
        return this.wallet;
    }

    private paymentsEnabled?: boolean;

    /**
     * Pagamenti online attivi? Stripe è spento lato backend in attesa di POK
     * (payments.stripe.enabled). Un backend che non espone il campo li ha attivi.
     */
    async isPaymentsEnabled(): Promise<boolean> {
        if (this.paymentsEnabled === undefined) {
            try {
                const response = await this.get('/v1/wallet/config');
                this.paymentsEnabled = response.data?.paymentsEnabled !== false;
            } catch {
                return true; // il backend resta l'arbitro: se è spento, il pagamento risponde 422
            }
        }
        return this.paymentsEnabled;
    }

    /** Il blocco lo calcola il backend (non pagato >= soglia). */
    get isBlocked(): boolean {
        return this.wallet?.blocked ?? false;
    }

    async payInvoice(invoiceId: number): Promise<PaymentIntentResponse> {
        const response = await this.post(`/v1/wallet/invoices/${invoiceId}/pay`);
        return response.data as PaymentIntentResponse;
    }

    /** Ritorno dalla pagina POK: il backend rilegge da POK i pagamenti in sospeso della clinica. */
    async syncPokPayments(): Promise<void> {
        await this.post('/v1/wallet/pok/sync');
    }

    /** Emette la fattura del residuo non fatturato e ne avvia il pagamento. */
    async payPending(): Promise<PaymentIntentResponse> {
        const response = await this.post('/v1/wallet/pay-pending');
        return response.data as PaymentIntentResponse;
    }
}
